import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Button, Checkbox, FormControlLabel, Paper, Typography } from '@mui/material';

import { BackButton, PageTitle } from '../../../../components/common';
import ButtonContainer from '../../../../components/ButtonContainer';

import { StyledVerticalContent } from './SelectTreatmentCategory.styled';

const SelectTreatmentCategories = ({
  backButtonLink,
  nextButtonLink,
  treatmentCategories,
  setTreatmentCategories,
  pageTitleId,
  pageDescriptionId,
  treatmentCategoryConfig,
}) => {
  const history = useHistory();
  const intl = useIntl();

  const validatedTreatmentCategories = Array.isArray(treatmentCategories)
    ? treatmentCategories
    : [];

  const validatedTreatmentCategoryConfig = Array.isArray(treatmentCategoryConfig)
    ? treatmentCategoryConfig
    : [];

  const handleTreatmentCategorySelection = (value) => {
    if (validatedTreatmentCategories.includes(value)) {
      setTreatmentCategories(validatedTreatmentCategories.filter((tc) => tc !== value));
    } else {
      setTreatmentCategories([...validatedTreatmentCategories, value]);
    }
  };

  return (
    <>
      <BackButton to={backButtonLink}>
        <Typography variant="h3">
          <FormattedMessage id="common.button.back" />
        </Typography>
      </BackButton>

      {pageTitleId && (
        <PageTitle>
          <Typography variant="h1">
            <FormattedMessage id={pageTitleId} />
          </Typography>
        </PageTitle>
      )}

      {pageDescriptionId && (
        <Typography variant="p" color="professional_blue" style={{ marginBottom: '1.5rem' }}>
          <FormattedMessage id={pageDescriptionId} />
        </Typography>
      )}

      <StyledVerticalContent>
        {validatedTreatmentCategoryConfig.map((item) => {
          const { label, value } = item || {};
          return (
            <Paper key={value}>
              <FormControlLabel
                variant="alignCenter"
                control={
                  <Checkbox
                    id={`treatment_category_checkbox_${value}`}
                    name={`treatment_category_checkbox_${value}`}
                    checked={validatedTreatmentCategories.includes(value)}
                    onChange={() => handleTreatmentCategorySelection(value)}
                    slotProps={{
                      input: {
                        'aria-label': intl.formatMessage({
                          id: label,
                        }),
                        'aria-checked': validatedTreatmentCategories.includes(value)
                          ? 'true'
                          : 'false',
                      },
                    }}
                  />
                }
                label={
                  <Typography variant="p">
                    <FormattedMessage id={label} />
                  </Typography>
                }
              />
            </Paper>
          );
        })}
      </StyledVerticalContent>

      <ButtonContainer>
        <Button
          disabled={validatedTreatmentCategories.length === 0}
          onClick={() => history.push(nextButtonLink)}
          data-testid="btn_treatment_cat_next"
        >
          <Typography variant="buttons">
            <FormattedMessage id="common.button.next" />
          </Typography>
        </Button>
      </ButtonContainer>
    </>
  );
};

export default SelectTreatmentCategories;
